<template>
  <div class="open_box" v-show="hideshow" @click.stop="$emit('click')">
    {{ text }}
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "打开App关注游戏社区",
    },
    keyShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hideshow: true,
    };
  },
  created() { },
  mounted() {
    window.addEventListener('resize', this.init)

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.init);
  },
  //监听
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight && this.keyShow) {
        console.log(this.docmHeight);
        console.log(this.showHeight);
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
    },
  },
  computed: {},
  methods: {
    init() {
      this.showHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
  },
};
</script>
<style lang="scss" scoped>
.open_box {
  position: fixed;
  bottom:20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  width: 300px;
  height: 40px;
  text-align: center;
  background: linear-gradient(90deg, #1D1D1D 0%, #5B4E3F 100%);
  font-size: 14px;
  color: #FFDB89;
  border-radius: 20px 20px 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
